import { maxDisplayWidth } from "@/constants/runtime.config.ts";
import { useAtom } from "jotai";
import { appAtom } from "@/atoms/app";
import { homeAtom } from "@/atoms/home";

export function useAppBgStyle(): React.CSSProperties {
  const [appState] = useAtom(appAtom);
  const homeData = useAtomValue(homeAtom);
  const locInfo = LocalStorage.getItem("INFO");
  const bgImageUrl = appState.appBgImageUrl;
  const isWeatherBgSet = homeData?.data?.info?.weatherBg || locInfo?.weatherBg;
  const _bgImage = `url(${bgImageUrl})`;
  return {
    ...(isWeatherBgSet && {
      backgroundImage: _bgImage,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    }),
    ...(isWeatherBgSet ? {} : { backgroundColor: "var(--app-bg-24)" }),
    zIndex: "-1",
    position: "fixed",
    maxWidth: `${maxDisplayWidth}px`,
    // width: "100vw",
    width: "100%",
    // height: "100dvh",
    height: "100vh",
  };
}
